import React from 'react';
import {CollectionAdvertisement} from 'domains/collections';
import SanityImage from 'components/SanityImage';
import {Link} from 'components/Link';
import clsx from 'clsx';

export default function CollectionAds(
  props: CollectionAdvertisement & {className: string},
) {
  if (props.ad_link && props.ad_link._type === 'linkInternal') {
    return (
      <article
        key="ads"
        className={clsx(
          'bg-hk-orange text-white flex items-center justify-center',
          props.className,
        )}
      >
        <Link to={props.ad_link.slug ?? '/'}>
          {props.ad_banner && (
            <SanityImage
              layout="responsive"
              sizes={['50vw, 100vw']}
              src={props.ad_banner?.asset._ref}
              alt={(props.ad_banner as {alt?: string})?.alt ?? ''}
              className="h-full object-cover"
            />
          )}
        </Link>
      </article>
    );
  }

  if (props.ad_link && props.ad_link._type === 'linkExternal') {
    return (
      <article
        key="ads"
        className={clsx(
          'bg-hk-orange text-white flex items-center justify-center',
          props.className,
        )}
      >
        <a href={props.ad_link.url} target="_blank" rel="noopener noreferrer">
          {props.ad_banner && (
            <SanityImage
              layout="responsive"
              sizes={['50vw, 100vw']}
              src={props.ad_banner?.asset._ref}
              alt={(props.ad_banner as {alt?: string})?.alt ?? ''}
              className="h-full object-cover"
            />
          )}
        </a>
      </article>
    );
  }

  return (
    <article
      key="ads"
      className={clsx(
        'bg-hk-orange text-white flex items-center justify-center',
        props.className,
      )}
    >
      {props.ad_banner && (
        <SanityImage
          layout="responsive"
          sizes={['50vw, 100vw']}
          src={props.ad_banner?.asset._ref}
          alt={(props.ad_banner as {alt?: string})?.alt ?? ''}
          className="h-full object-cover"
        />
      )}
    </article>
  );
}
